/* eslint-disable no-nested-ternary */
import React from 'react';
import { Col, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import DateFormatter from 'components/DateFormatter';
import VendorList from './components/VendorList';

const OfferCouponDetails = ({ coupon }) => {
  return (
    <>
      <CardWithTitle title="Coupon Details">
        <Row>
          <Col sm={6} lg={3} className="mt-3 mt-sm-0">
            <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
              COUPON CODE
            </span>
            <span className="f-12 text-dark-525 fw-medium d-block">
              {coupon?.code ? coupon?.code : 'Not Available'}
            </span>
          </Col>

          <Col sm={6} lg={3} className="mt-3 mt-sm-0">
            <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
              DISCOUNT Value
            </span>
            <span className="f-12 text-dark-525 fw-medium d-block">
              {coupon?.discountValue
                ? `${coupon?.discountType === 'FLAT' ? (coupon.currency?.id === '233' ? '$' : '₹') : ''}${coupon?.discountValue}${coupon?.discountType === 'PERCENTAGE' ? '%' : ''}`
                : 'Not Available'}
            </span>
          </Col>

          <Col sm={6} lg={2} className="mt-3 mt-lg-0">
            <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
              USAGE LIMIT
            </span>
            <span className="f-12 text-dark-525 fw-medium d-block">
              {coupon?.usageLimit
                ? `${coupon?.usageCount}/${coupon?.usageLimit}`
                : 'Not Available'}
            </span>
          </Col>
          <Col sm={6} lg={4} className="mt-3 mt-lg-0 mb-2">
            <span className="f-12 text-active fw-medium d-block text-uppercase mb-1">
              Validity Period
            </span>
            <span className="f-12 text-dark-525 fw-medium d-flex align-items-center">
              {coupon?.fromDate && coupon?.expiryDate ? (
                <>
                  <DateFormatter dateTime={coupon?.fromDate} />
                  <span className="mx-3">-</span>
                  <DateFormatter dateTime={coupon?.expiryDate} />
                </>
              ) : (
                'Not Available'
              )}
            </span>
          </Col>
        </Row>
      </CardWithTitle>
      <CardWithTitle title="Vendor">
        <VendorList couponId={coupon?.id} />
      </CardWithTitle>
    </>
  );
};

export default OfferCouponDetails;
